// extracted by mini-css-extract-plugin
export default {"input":"CodeInput_input__SN0pL"};